<template>

    <div class="card ft-bld">
        <div class="pic cvr" :style="{ backgroundImage : 'url('+ posterSrc +')' }"></div>
        <div class="tp">
            <span class="m-tag">{{ moneyTag }}</span>
            <span class="del" @click.prevent="toggleDel" v-if="canDelete">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2H16.5C17.3284 2 18 2.67157 18 3.5C18 4.32843 17.3284 5 16.5 5H16V16C16 17.6569 14.6569 19 13 19H5C3.34315 19 2 17.6569 2 16V5H1.5C0.671573 5 0 4.32843 0 3.5C0 2.67157 0.671573 2 1.5 2H5C5 0.895431 5.89543 0 7 0H11C12.1046 0 13 0.895431 13 2ZM5 14.5C5 15.3284 5.67157 16 6.5 16C7.32843 16 8 15.3284 8 14.5V8.5C8 7.67157 7.32843 7 6.5 7C5.67157 7 5 7.67157 5 8.5V14.5ZM11.5 16C10.6716 16 10 15.3284 10 14.5V8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V14.5C13 15.3284 12.3284 16 11.5 16Z" fill="white"/>
                </svg>
            </span>
        </div>
        <div class="btm col">
            <span class="cap-title ft-xbld">{{ title }}</span>
            <div class="tags">
                <span class="tag" v-for="tag, index in genreTags" :key="index" v-show="index < 2">{{ tag }}</span>
                <span class="more" v-if="genreTags.length > 2">+{{ genreTags.length - 2 }}</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'ContentCard',

        props: {
            index: Number,
            posterSrc: String,
            moneyTag: String,
            title: String,
            genreTags: {
                type: Array,
                default: () => ([])
            },
            canDelete: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                Global,

            }
        },

        methods: {

            toggleDel() {
                this.Global.contentIndexToDelete = this.index
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activeDelOverlay = true
            }

        }
    }
</script>